// utils/dateFormatter.js
export const formatToIST = (timestamp) => {
    if (!timestamp) return "N/A"; // Handle null or undefined timestamps

    try {
        const date = new Date(timestamp);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    } catch (error) {
        console.error("Error formatting timestamp:", error);
        return "Invalid Date"; // Fallback for invalid timestamps
    }
};


export const formatTimeToIST = (timestamp) => {
    if (!timestamp) return "N/A"; // Handle null or undefined timestamps

    try {
        const date = new Date(timestamp);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    } catch (error) {
        console.error("Error formatting timestamp:", error);
        return "Invalid Date"; // Fallback for invalid timestamps
    }
};


export const formattedTripDate = (date) => {
    if (!date) {
        return "N/A"; // Return "N/A" if the date is null or undefined
      }
    const options = {
      day: "numeric",
      month: "numeric",
      year: "numeric",
     
    };
    const formattedDate = new Date(date);
    console.log("formattedTripDate",formattedDate)
    return formattedDate.toLocaleString("en-GB", options);
  };

  export const formattedTripTime = (date) => {
    if (!date) {
        return "N/A"; // Return "N/A" if the date is null or undefined
      }
    const options = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
     
    };
    const formattedTime = new Date(date);
    return formattedTime.toLocaleTimeString("en-GB", options);
  };
